// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19OSX","top":"styles_top__3XI-4","left":"styles_left__4E7jc","description":"styles_description__11tQU"};